import BulletinSelectedItemLabel from 'components/atoms/bulletin_selected_item_label';
import ItemShare from 'components/atoms/item_share';
import Pagination from 'components/atoms/pagination';
import SelectButton from 'components/atoms/select_button';
import ItemTools from 'components/molecules/item_tools';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getDownloadBulletin } from 'services/actions/bulletins';
import { spliceArray } from 'services/splice_array';
import { StatesList } from 'services/states';
import { toggleSelected } from 'services/toggleSelected';
import { ApplicationState } from 'store';
import {
  BulletinFollowupTypes,
  BulletinsState,
  BulletinsTypes,
  FilterBulletinTypes,
} from 'store/modules/bulletins_store/types';
import _ from 'underscore';
import TotalEntriesLabel from 'components/atoms/total_entries_label';
import FollowupItem from 'components/molecules/followup_item';
import EmptyResult from 'components/atoms/empty_result';
import { useReactToPrint } from 'react-to-print';
import { Container } from './styles';

interface BulletinFollowupsProps {
  bulletin_filter_id: number;
  bulletinFilterIndex: number;
  selectedFollowups: Array<number>;
  selectedBiddings: Array<number>;
  setSelectedFollowups: React.Dispatch<React.SetStateAction<Array<number>>>;
  setSelectedBiddings: React.Dispatch<React.SetStateAction<Array<number>>>;
  toogleSelectWholeBulletin: () => void;
  wholeBulletinSelected: boolean;
}

interface SelectValuesTypes {
  value: number;
  label: string;
}

const BulletinFollowups = (props: BulletinFollowupsProps) => {
  const PAGE_SIZE = 50;
  const {
    bulletin_filter_id,
    bulletinFilterIndex,
    selectedFollowups,
    setSelectedFollowups,
    setSelectedBiddings,
    selectedBiddings,
    toogleSelectWholeBulletin,
    wholeBulletinSelected,
  } = props;

  const { bulletins, request } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );

  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState<number>(
    bulletins?.bulletins_followups_list[bulletin_filter_id]?.current_page || 1,
  );
  const [followupList, setFollowupList] = useState<Array<BulletinFollowupTypes>>([]);
  const [filteredList, setFilteredList] = useState<Array<BulletinFollowupTypes>>([]);
  const [followupCount, setFollowupCount] = useState<number>(0);
  const [statesFilter, setStatesFilter] = useState<Array<SelectValuesTypes>>([]);
  const [selectedStatesFilter, setSelectedStatesFilter] = useState<Array<SelectValuesTypes>>([]);
  const [wholePageSelected, setWholePageSelected] = useState<boolean>(false);
  const [showShareWindow, setShowShareWindow] = useState<boolean>(false);
  const [scrollToolsClass, setScrollToolsClass] = useState<string>('');
  const [filterBulletin, setFilterBulletin] = useState<FilterBulletinTypes>();
  const [loadedFilter, setLoadedFilter] = useState<boolean>(false);

  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const toggleSelectedFollowups = (id: number, updateAll = false) => {
    toggleSelected({
      id,
      updateAll,
      selectedList: selectedFollowups,
      setSelectedList: setSelectedFollowups,
      sourceList: followupList,
      wholePageSelected,
    });
  };

  const updateCurrentPage = (currentPage = 1) => {
    dispatch({
      type: BulletinsTypes.UPDATE_CURRENT_PAGE_FOLLOWUPS,
      current_page: currentPage,
      bulletin_id: bulletin_filter_id,
    });
    setCurrentPage(currentPage);

    document.querySelector('#windowDiv')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const pages = Array.from(
      { length: bulletins.bulletins_followups_list[bulletin_filter_id].total_pages },
      (_, i) => i + 1,
    ).map((page) => `bulletin_${bulletin_filter_id}_page_${page}`);

    const isNotLoaded = pages.find((page) => {
      if (!request.fetch_bulletin_followups[page]) return true;
      if (!request.fetch_bulletin_followups[page]?.loaded) return true;

      return false;
    });

    if (!isNotLoaded) setLoadedFilter(true);
    if (isNotLoaded) setLoadedFilter(false);
  }, [request?.fetch_bulletin_followups, bulletins.bulletins_followups_list]);

  useEffect(() => {
    const windowDiv = document.getElementById('windowDiv');
    windowDiv?.addEventListener('scroll', () => {
      setScrollToolsClass(windowDiv?.scrollTop > 10 ? 'border-bottom' : '');
    });

    if (!bulletins?.bulletins_followups_list[bulletin_filter_id]) return;

    setFollowupCount(bulletins.bulletins_followups_list[bulletin_filter_id].total_entries);
    setCurrentPage(bulletins?.bulletins_followups_list[bulletin_filter_id]?.current_page);
  }, []);

  useEffect(() => {
    const stateIds = _.uniq(
      bulletins.bulletins_followups_list[bulletin_filter_id].followups.map(
        (followup) => followup.orgao_estado_id,
      ),
    )
      .map((stateId) => StatesList.find((state) => state.id === stateId))
      .filter((state) => state);

    setStatesFilter(
      stateIds.map((state) => {
        return {
          value: state?.id || 0,
          label: state?.name || '',
        };
      }),
    );

    const filterBulletinIndex = bulletins?.filter_bulletins?.findIndex(
      (filter_bulletin) =>
        filter_bulletin?.bulletin_filters.filter(
          (bulletin_filter) => bulletin_filter?.id === bulletin_filter_id,
        )[0]?.id === bulletin_filter_id,
    );
    setFilterBulletin(bulletins?.filter_bulletins[filterBulletinIndex]);
  }, [loadedFilter]);

  useEffect(() => {
    setFollowupCount(filteredList.length);

    if (filteredList.length === 0) {
      setFollowupList([]);
      return;
    }

    setFollowupList(spliceArray(filteredList, PAGE_SIZE)[currentPage - 1]);
  }, [currentPage, filteredList]);

  useEffect(() => {
    if (!followupList) return;

    setWholePageSelected(
      followupList
        ?.map((followup) => Number(followup.followup_id))
        .filter((followup) => selectedFollowups.includes(followup))?.length === followupList.length,
    );
  }, [
    selectedFollowups,
    bulletins.bulletins_followups_list[bulletin_filter_id]?.current_page,
    followupList,
  ]);

  useEffect(() => {
    if (!bulletins.bulletins_followups_list[bulletin_filter_id]?.followups) return;

    const selectedStatesIds = selectedStatesFilter.map((state) => state.value);
    let newFilteredList = bulletins.bulletins_followups_list[bulletin_filter_id]?.followups;

    if (selectedStatesIds.length > 0) {
      newFilteredList = newFilteredList.filter((followup) =>
        selectedStatesIds.includes(followup.orgao_estado_id),
      );
    }

    setFilteredList(newFilteredList);
  }, [selectedStatesFilter, bulletins.bulletins_followups_list[bulletin_filter_id]?.followups]);

  useEffect(() => {
    if (selectedStatesFilter.length > 0) {
      updateCurrentPage();
      setSelectedFollowups([]);
    }
  }, [selectedStatesFilter]);

  const downloadFile = (fileExtension: string) => {
    getDownloadBulletin(
      fileExtension,
      'followup',
      bulletin_filter_id,
      wholeBulletinSelected ? [] : selectedFollowups,
      bulletins.filter_bulletins[bulletinFilterIndex]?.bulletin_filters?.filter(
        (bulletin_filter) => bulletin_filter?.id === bulletin_filter_id,
      )[0].issue,
      bulletins.filter_bulletins[bulletinFilterIndex]?.filter?.description,
    );
  };

  const handleShare = () => {
    setShowShareWindow(!showShareWindow);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: 'conlicitacao',
  });

  return (
    <Container>
      <div className="row d-print-none position-relative" style={{ zIndex: '101' }}>
        <div className="col-12 col-md-4">
          <div className="mb-1">Estados</div>
          <Select
            isLoading={!loadedFilter}
            loadingMessage={() => 'Carregando situações'}
            name="StateFilterSearch"
            isMulti
            value={selectedStatesFilter}
            closeMenuOnSelect={false}
            onChange={(event) => setSelectedStatesFilter([...event])}
            options={loadedFilter ? statesFilter : []}
            placeholder={loadedFilter ? 'Filtre por estado' : 'Carregando estados'}
            className="basic-multi-select"
            noOptionsMessage={() => 'Sem opções'}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 mx-auto px-0 px-md-3">
          <div className={`row list-tools py-1 ${scrollToolsClass}`}>
            {followupList?.length > 0 && (
              <div className="position-relative col-lg-6 d-block py-3 px-2">
                <SelectButton
                  isChecked={wholePageSelected}
                  id={0}
                  toggleSelected={toggleSelectedFollowups}
                  text="Selecionar página"
                />
                <SelectButton
                  isChecked={wholeBulletinSelected}
                  id={0}
                  toggleBulletin={toogleSelectWholeBulletin}
                  text="Selecionar boletim"
                />
                <BulletinSelectedItemLabel
                  selectedBiddings={selectedBiddings}
                  selectedFollowups={selectedFollowups}
                  setSelectedBiddings={setSelectedBiddings}
                  setSelectedFollowups={setSelectedFollowups}
                />
              </div>
            )}
            <ItemTools
              enabledButtons={selectedFollowups?.length > 0}
              disabledPopoverLabel="a licitação"
              downloadFile={downloadFile}
              handleShare={handleShare}
              handlePrint={handlePrint}
            />
            {showShareWindow && (
              <ItemShare
                setShowShareWindow={setShowShareWindow}
                selectedItems={selectedFollowups}
                source="followup"
              />
            )}
          </div>
          <div className="row">
            <div className="col-md-12 d-flex align-items-center justify-content-end text-secondary">
              <TotalEntriesLabel
                itemLabel={followupCount === 1 ? 'acompanhamento' : 'acompanhamentos'}
                totalEntries={followupCount}
              />
            </div>
          </div>
          <div ref={componentRef} className="row mx-1 mt-5">
            <div className="col-12">
              {bulletins?.bulletins_followups_list[bulletin_filter_id]?.total_entries > 0 &&
                followupList?.map((followup, index) => (
                  <FollowupItem
                    key={followup.followup_id}
                    followup={followup}
                    isChecked={selectedFollowups.includes(followup.followup_id)}
                    followupIndex={
                      index +
                      (Number(
                        bulletins?.bulletins_followups_list[bulletin_filter_id]?.current_page,
                      ) -
                        1) *
                        PAGE_SIZE
                    }
                    toggleSelected={toggleSelectedFollowups}
                    followupKeywords={filterBulletin?.followup_keywords || []}
                  />
                ))}
              {bulletins?.bulletins_followups_list[bulletin_filter_id]?.total_entries === 0 && (
                <div className="col-md-12 text-center">
                  <h2 className="text-secondary mt-3">Resultado não encontrado.</h2>
                  <h5 className="text-secondary mt-3">
                    Esse boletim não tem licitações ou não temos licitações que correspondam a esses
                    filtros.
                  </h5>
                </div>
              )}
            </div>
          </div>
          <div className="row d-print-none">
            {request?.fetch_bulletin_followups[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
              ?.error && (
              <EmptyResult title="Desculpe!" description="Algo deu errado, tente novamente." />
            )}
            {request.fetch_bulletin_followups[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
              ?.loaded &&
              bulletins.bulletins_followups_list[bulletin_filter_id]?.total_entries > PAGE_SIZE &&
              bulletins.bulletins_followups_list[bulletin_filter_id]?.total_entries !== 0 && (
                <div className="col-12 mx-auto mb-1 pb-1 px-4">
                  <Pagination
                    postsPerPage={PAGE_SIZE}
                    totalPosts={filteredList.length}
                    paginate={updateCurrentPage}
                    currentPage={
                      bulletins?.bulletins_followups_list[bulletin_filter_id]?.current_page
                    }
                    firstAndLastPage
                  />
                </div>
              )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BulletinFollowups;
